export default class AdvertisingProviderChannelGroupService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('advertisingProviderChannelGroups/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('advertisingProviderChannelGroups', params)
	}

	getEntitiesByProviderId(id, params) {
		return this.apiService.callGet('advertisingProviderChannelGroups', {...params, 'id_advertising_provider': id})
	}

	createEntity(params) {
		return this.apiService.callPost('advertisingProviderChannelGroups', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('advertisingProviderChannelGroups/' + id, params)
	}

	updateChannel(id, params) {
		return this.apiService.callPut('advertisingProviderChannelGroups/' + id + '/channel', params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('advertisingProviderChannelGroups/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/AdvertisingProviderChannelGroupService.js